import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../images/logo text.png" 
import Calendar from 'moedim';
import { AuthContext } from "../Auth";

const T1 = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [reason, setReason] = useState("");
  const [value, setValue] = useState(new Date());

  console.log(currentUser.uid)

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedTime(""); // Clear selected time when a new date is selected
    setName("");
    setSurname("");
    setReason("");
  };
  console.log(selectedDate);
  console.log(selectedTime);

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };

  const handleAppointmentSubmit = () => {
    console.log("Selected Date:", selectedDate);
    console.log("Selected Time:", selectedTime);
    console.log("Name:", name);
    console.log("Surname:", surname);
    console.log("Reason for Appointment:", reason);
  };

  console.log(value)
  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };


  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>


    <br/>
  <br/>
  <br/>
  <br/>
  <div className="app container p-5">
      <h1 className="text-center mb-2">ตารางออกตรวจแพทย์</h1>
      <Table className="table table-hover table-bordered p-5 text-center ">
      <thead>
        <tr>
          <th>วัน</th>
          <th>เวลา</th>
          <th>สถานที่</th>
          
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>อาทิตย์</td>
          <td>10:00 - 12:00/13:00 - 14:00</td>
          <td>ศูนย์โรคหัวใจ ชั้น 9 อาคารเฉลิมพระเกียรติฯ</td>
        </tr>
      </tbody>
    </Table>
        <p>ตารางออกตรวจอาจมีการเเปลี่ยนแปลง สอบถามเพิ่มเติมได้ที่ 053-936900 , 053-936901 , 065-4724657 , 065-4724658</p>
       </div>
       
       <div>
        <Calendar className="Calendar" value={value} onChange={(d) => setValue(d)}  />
        {value && (
          <div>
            <p className="Datepicker">
              Selected Date: {value.toLocaleDateString(undefined, { weekday: 'long' })}
              {value.getDay() === 5 && (
                <div>
                  <h2>Doctor is available. Please select a time:</h2>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("13:00-13:30")}
                  >
                    13:00-13:30 
                  </button>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("14:00-14:30")}
                  >
                    14:00-14:30
                  </button>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("14:45-15:15")}
                  >
                    14:45-15:15
                  </button>
                  <button
                    className="btn-solid-lg page-scroll mx-3 my-4"
                    type="button"
                    onClick={() => handleTimeSelect("16:30-17:00")}
                  >
                    16:30-17:00
                  </button>
                  <button  style={{marginTop: "4%"}} className="btn-solid-lgr" onClick={(e) => {
                  e.preventDefault();
                  window.location.href='https://account.line.biz/login?redirectUri=https%3A%2F%2Fchat.line.biz%2FUabcee59505493f1de2653a06b773de90';
                  }}>
                  ติดต่อแพทย์

                  </button>
                </div>
              )}
            </p>
            {selectedTime && value.getDay() === 5 && (
              <div>
                <h2>Appointment Information</h2>
                <input
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Surname"
                  value={surname}
                  onChange={(e) => setSurname(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Reason for Appointment"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
                <button
                  className="btn-solid-lg page-scroll mx-3 my-4"
                  type="button"
                  onClick={handleAppointmentSubmit}
                >
                  Submit Appointment
                </button>
              </div>
            )}
          </div>
        )}
      </div>

       
       

      
    </>
  );
};

export default withRouter(T1);